// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "lang-3TjWo";
var _3 = "lang_opened-bd7no";
var _4 = "lang__selected-1fI7x";
var _5 = "dropdown-3ykOJ";
var _6 = "dropdown__item-2dmA5";
var _7 = "selected-1Hp8b";
var _8 = "dropdown__icon-2xpcG";
export { _1 as "__esModule", _2 as "lang", _3 as "lang_opened", _4 as "lang__selected", _5 as "dropdown", _6 as "dropdown__item", _7 as "selected", _8 as "dropdown__icon" }
export default { "__esModule": _1, "lang": _2, "lang_opened": _3, "lang__selected": _4, "dropdown": _5, "dropdown__item": _6, "selected": _7, "dropdown__icon": _8 }
